const footerNavigation = {
	company: [
		{
			name: 'Contact',
			href: '/#contact',
		},
		{
			name: 'Services',
			href: '/services',
		},
	],
	legal: [
		{
			name: 'Privacy Policy',
			href: '/privacy',
		},
		{
			name: 'Terms of Service',
			href: '/terms',
		},
	],
	solutions: [
		{
			name: 'Login',
			href: '/login',
		},
		{
			name: 'Sign Up',
			href: '/signup',
		},
	],
	support: [
		// {
		// 	name: 'Help',
		// 	href: '/help',
		// },
		// {
		// 	name: 'FAQ',
		// 	href: '/faq',
		// },
	],
};
export default footerNavigation;
